import { URLS } from "@/lib/consts";
import { formatForLabel } from "@/lib/utils/string";

export type HrefLabel = {
  href: string;
  label: string;
};

export type PeerMap = Record<string, HrefLabel[]>;

export interface UrlTree {
  [key: string]: string | UrlTree;
}

export function flattenUrlsWithPeers(
  obj: UrlTree = URLS,
  excludedKeys: string[] = ["home", "root"],
  parent: { value: string | UrlTree } = { value: "/" },
) {
  const flat: HrefLabel[] = [];
  const peerMap: PeerMap = {};

  for (const [key, value] of Object.entries(obj)) {
    if ([...excludedKeys, "root"].includes(key.toLowerCase())) {
      continue;
    }

    if (typeof value === "string") {
      const label = formatForLabel(key);
      const href = value;

      flat.push({ href, label });

      const parentUrl =
        typeof parent.value === "object"
          ? (parent.value.ROOT as string)
          : parent.value;

      if (parentUrl) {
        peerMap[parentUrl] = peerMap[parentUrl] || [];
        peerMap[parentUrl].push({ href, label });
      }
    }

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      const href = value.ROOT as string;
      const label = formatForLabel(key);

      flat.push({ href, label });

      const parentUrl =
        typeof parent.value === "object"
          ? (parent.value.ROOT as string)
          : parent.value;

      if (parentUrl) {
        peerMap[parentUrl] = peerMap[parentUrl] || [];
        peerMap[parentUrl].push({ href, label });
      }

      const child = flattenUrlsWithPeers(value, excludedKeys, {
        value,
      });

      flat.push(...child.flat);

      for (const [k, v] of Object.entries(child.peerMap)) {
        peerMap[k] = peerMap[k] || [];
        peerMap[k].push(...v);
      }
    }
  }

  return { flat, peerMap };
}
